module.exports = "<div class=\"row wrapper border-bottom white-bg page-heading personal-account-header\">\r\n    <div class=\"col-lg-12\">\r\n        <h2>Team Members</h2>\r\n    </div>\r\n</div>\r\n\r\n<div class=\"help-team-members-page personal-account-page\">\r\n    <div class=\"help-content-scroll help-content-body\" [innerHTML]=\"content\"></div>\r\n</div>\r\n";


//////////////////
// WEBPACK FOOTER
// ./Client/app/views/account.management/help/help.team-members.component.html
// module id = 1152
// module chunks = 0